module.exports = __webpack_public_path__ + "static/vmware_29.aab30bee.jpg";